// src/components/Footer.jsx
import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        // position: "sticky",
        // bottom: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#fff",
        padding: "1.5rem",
        flexWrap: "wrap", // Wrap content on small screens
        // borderTop: "1px solid #ddd",
      }}
    >
      <Typography variant="body2">
        &copy; 2024 Alchemy Collective. All Rights Reserved.
      </Typography>

      <Box>
        <IconButton
          component="a"
          href="https://www.instagram.com/alchemycollective.20/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          sx={{ color: "inherit" }}
        >
          <InstagramIcon />
        </IconButton>
        <IconButton
          component="a"
          href="mailto:info.alchemycollective@gmail.com"
          aria-label="Email"
          sx={{ color: "inherit" }}
        >
          <EmailIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Footer;
